export default {"src":"/_next/static/media/icon_listV2.92c5a786.svg","height":27,"width":25,"blurWidth":0,"blurHeight":0};